import {
	SET_PROJECTS,
	SET_PROJECT,
	CLEAR_PROJECTS,
	CLEAR_PROJECT,
	ADD_PROJECT,
	UPDATE_PROJECT,
	REMOVE_PROJECT,
} from './actionTypes';

export const project = (state = {}, action) => {
	switch (action.type) {
		case SET_PROJECT:
			return action.payload;
		case UPDATE_PROJECT:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_PROJECT:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_PROJECTS:
			return action.payload;
		case ADD_PROJECT:
			return [...state, action.payload];
		case UPDATE_PROJECT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_PROJECT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_PROJECTS:
			return [];
		default:
			return state;
	}
};
